module.exports = __webpack_public_path__ + "img/survey_top_new.ef6c77d4.jpg";